import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "searchBoxOverlayInner" }
const _hoisted_2 = { class: "searchBoxTitle" }
const _hoisted_3 = { class: "searchInputInner" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "globalSearchFilterInput" }, null, -1)
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 18",
  preserveAspectRatio: "xMinYMid",
  "aria-hidden": "true",
  role: "img",
  fill: "#1A1347"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M315.25 20.25V31H326v1.5h-10.75v10.75h-1.5V32.5H303V31h10.75V20.25h1.5z",
      transform: "translate(-305 -79) translate(0 56) rotate(45 314.5 31.75)"
    })
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Web.Components.SearchBoxCTA")), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["searchInputWrapper", _ctx.keywordError && 'searchError'])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          id: "globalSearchFilterInput",
          onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.trySearch && _ctx.trySearch(...args)), ["prevent"]), ["enter"])),
          type: "search",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.keyword) = $event)),
          autocomplete: "off"
        }, null, 544), [
          [_vModelText, _ctx.keyword]
        ]),
        (_ctx.keyword.length > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "clearButton",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearKeyword && _ctx.clearKeyword(...args))),
              "aria-label": _ctx.$t('Web.Containers.ClearKeyword')
            }, _hoisted_7, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        type: "submit",
        class: "searchButton",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.trySearch && _ctx.trySearch(...args))),
        disabled: !_ctx.keywordLengthOK(),
        "aria-label": _ctx.$t('Web.Containers.SubmitSearch')
      }, _toDisplayString(_ctx.$t("Web.Containers.Search")), 9, _hoisted_8)
    ], 2)
  ]))
}